import { SITE } from "@/config";
import { useRevealAnimation, useTextReveal } from "@/motion/hooks";

const tools = ["Higgsfield", "Seedance", "Nano Banana", "Kling", "Veo", "Midjourney", "HeyGen", "Soul", "ElevenLabs", "Claude Code"];

export default function About() {
    const revealRef = useRevealAnimation("cinematic", { children: "[data-reveal]", stagger: "base" });
    const bodyReveal = useTextReveal("words");
    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative border-b border-[color:var(--line)] py-24 md:py-36"
        >
            <div className="mx-auto max-w-[1000px] px-6 md:px-10">
                <p className="text-[10px] uppercase tracking-luxe text-[color:var(--gold)]">
                    About
                </p>
                <p
                    ref={bodyReveal}
                    className="font-display mt-6 text-3xl md:text-[2.6rem] leading-[1.25] text-[color:var(--fg)]/90"
                >
                    I&apos;m Nikhil Joshi — an AI visual creator and AI filmmaker with ten-plus
                    years across marketing and content. I make cinematic, luxury-grade AI films
                    and visuals that give brands presence. Based in {SITE.locality}, India —
                    working with brands everywhere.
                </p>

                <div className="mt-12 border-t border-[color:var(--line)] pt-8">
                    <p className="text-[10px] uppercase tracking-luxe text-[color:var(--muted)]">
                        Tools of the craft
                    </p>
                    <div className="mt-4 flex flex-wrap gap-x-10 gap-y-3">
                        {tools.map((t) => (
                            <span
                                key={t}
                                className="font-display text-xl md:text-2xl text-[color:var(--fg)]/80"
                            >
                                {t}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
